import { render, staticRenderFns } from "./TableGoalsVendorns.vue?vue&type=template&id=ad0fde34&scoped=true&"
import script from "./TableGoalsVendorns.vue?vue&type=script&lang=js&"
export * from "./TableGoalsVendorns.vue?vue&type=script&lang=js&"
import style0 from "./TableGoalsVendorns.vue?vue&type=style&index=0&id=ad0fde34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0fde34",
  null
  
)

export default component.exports